export class Config {
  public static config = {
    theme: 'default', // default, collapse, horizontal
    themeType: 'light' // default, dark, light
  };
}
